import { getPreference, removePreference, setPreference } from './preferences.js';

export const TRUST_QR_ALIASES = Object.freeze({
  rsch: 'rsch_uhs',
  'royal-sussex-county-hospital': 'rsch_uhs',
});

export const QR_CAMPAIGN_STORAGE_KEY = 'kyc_qr_campaign';
export const QR_CONFIGURED_TRUST_KEY = 'kyc_qr_configured_trust';
export const QR_CONFIGURATION_ERROR_KEY = 'kyc_qr_configuration_error';
const CAMPAIGN_PATTERN = /^[a-z0-9][a-z0-9_-]{0,79}$/;

export function resolveTrustQrValue(value) {
  const normalized = String(value || '').trim().toLowerCase();
  if (!normalized) return null;
  return TRUST_QR_ALIASES[normalized] || normalized;
}

export function normalizeCampaign(value) {
  const normalized = String(value || '').trim().toLowerCase();
  return CAMPAIGN_PATTERN.test(normalized) ? normalized : null;
}

export function persistQrCampaign(value) {
  const campaign = normalizeCampaign(value);
  if (campaign) setPreference(QR_CAMPAIGN_STORAGE_KEY, campaign, { storage: 'session' });
  return campaign;
}

export function getQrCampaign() {
  return normalizeCampaign(getPreference(QR_CAMPAIGN_STORAGE_KEY, null, { storage: 'session' }));
}

export function markQrConfiguredTrust(trustId) {
  if (!trustId) return false;
  return setPreference(QR_CONFIGURED_TRUST_KEY, trustId, { storage: 'session' });
}

export function getQrConfiguredTrust() {
  return getPreference(QR_CONFIGURED_TRUST_KEY, null, { storage: 'session' });
}

export function setQrConfigurationError(errorCode) {
  if (!errorCode) return false;
  return setPreference(QR_CONFIGURATION_ERROR_KEY, errorCode, { storage: 'session' });
}

export function consumeQrConfigurationError() {
  const errorCode = getPreference(QR_CONFIGURATION_ERROR_KEY, null, { storage: 'session' });
  removePreference(QR_CONFIGURATION_ERROR_KEY, { storage: 'session' });
  return errorCode;
}
